import styled from 'styled-components';
import { mvpGreenPrimary, mvpGreenText, white } from 'src/styles';
import { ISigningCaseDetailsHeader } from 'src/components/PortalList/PortalSigningCaseDetails/SigningCaseDetails/components/SigningCaseHeader/interfaces';
import {
  getMvpAppSigningCaseFontColor,
  getMvpAppSigningCaseHeaderColor,
} from 'src/utils/getSigningCaseHeaderColor';
import { DocumentTag } from 'src/components/Tag/DocumentTag';
import { IDocumentResponse } from 'src/models';

interface TagTextProps {
  uppercase?: boolean;
  isFromMvpApp?: boolean;
  status?: ISigningCaseDetailsHeader['status'];
}

const getColor = (props: TagTextProps) =>
  getMvpAppSigningCaseFontColor(
    props.status !== undefined ? props.status : 'Manual'
  );

export const TagText = styled.span<TagTextProps>`
  color: ${({ isFromMvpApp, status }) =>
    isFromMvpApp ? getColor({ isFromMvpApp, status }) : white};
  font-family: 'Danske', 'Tahoma', Sans-Serif, serif;
  font-size: 0.9em;
  text-transform: ${props => (props.uppercase ? 'uppercase' : 'none')};
`;

export const DateText = styled.span`
  margin-left: 0.5em;
`;

interface TagContainerProps {
  color?: string;
  isFromMvpApp?: boolean;
}

export const TagContainer = styled.div<TagContainerProps>`
  background-color: ${props => props.color};
`;

export const Container = styled.div<TagContainerProps>`
  position: absolute;
  background-color: ${props => props.color};
  top: -3px;
  right: 0;
  padding: 0 6px 3px;
  border-bottom-left-radius: 3px;
`;
interface ITagProps {
  status: ISigningCaseDetailsHeader['status'];
  document: IDocumentResponse;
}

export const getHeaderColor = ({ status, document }: ITagProps) => {
  if (
    (status === 'NotSigned' || status === 'PartiallySigned') &&
    document.isRead
  ) {
    return mvpGreenPrimary;
  } else {
    return getMvpAppSigningCaseHeaderColor(status);
  }
};

export const getFontColor = ({ status, document }: ITagProps) => {
  if (
    (status === 'NotSigned' || status === 'PartiallySigned') &&
    document.isRead
  ) {
    return mvpGreenText;
  } else {
    return getMvpAppSigningCaseFontColor(status);
  }
};

export const DocumentTagStyled = styled(DocumentTag)`
  margin-top: 10px;
  font-family: 'Danske', 'Tahoma', Sans-Serif, sans-serif;
  padding: 4px 10px;
  background-color: ${getHeaderColor};
  border-radius: 6px;
  color: ${getFontColor};
`;
